export const SHOTS_ERROR_TEXTS = {
  required: 'is required.',
  invalidDateFormat: 'Please enter a valid date.',
  min: 'must be greater than',
  max: 'must not exceed',
};

export const DATE_FORMATS = {
  parse: {
    dateInput: ['M/D/YYYY', 'MM/DD/YYYY'],
  },
  display: {
    dateInput: 'M/D/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'MM/DD/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
